"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Alphanumeric = _interopRequireWildcard(require("./types/Alphanumeric"));

var _Email = _interopRequireDefault(require("./types/Email"));

var _Boolean = _interopRequireDefault(require("./types/Boolean"));

var _Regex = _interopRequireDefault(require("./types/Regex"));

var _Number = _interopRequireWildcard(require("./types/Number"));

var _Date = _interopRequireWildcard(require("./types/Date"));

var _Array = _interopRequireDefault(require("./types/Array"));

var _errors = _interopRequireDefault(require("./errors"));

var _getMinMaxErrorMessage = _interopRequireDefault(require("./helpers/getMinMaxErrorMessage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// types
var validatorMatch = {
  alphanumeric: _Alphanumeric.default,
  phoneNumber: _Alphanumeric.phoneNumber,
  ascii: _Alphanumeric.Ascii,
  email: _Email.default,
  integer: _Number.default,
  decimal: _Number.decimal,
  boolean: _Boolean.default,
  date: _Date.default,
  date_mm_dd_yyyy: _Date.MMDDYYYY,
  dateTime: _Date.dateTime,
  array: _Array.default
};
/**
    validator('testuser@gmail.com', {
        types: ['alphanumeric', 'email'],
        min: 1,
        max: 255,
        regex: '',
    })
 */

var _default = function _default(input, validatorSettings) {
  var pass = true;
  var errors = {};

  if (validatorSettings.types.includes('regex') && 'regex' in validatorSettings) {
    if (!(0, _Regex.default)(input, validatorSettings.regex)) {
      pass = false;
      errors.regex = _errors.default.regex;
    }
  } else {
    validatorSettings.types.forEach(function (type) {
      if (!validatorMatch[type](input)) {
        pass = false;
        errors[type] = _errors.default[type];
      }
    });
  }

  var minMaxError = (0, _getMinMaxErrorMessage.default)(input, validatorSettings);

  if (validatorSettings.min > (Array.isArray(input) ? input.length : input.toString().length)) {
    pass = false;
    errors.min = minMaxError;
  }

  if (validatorSettings.max < (Array.isArray(input) ? input.length : input.toString().length)) {
    pass = false;
    errors.max = minMaxError;
  }

  if (pass) {
    return {
      status: 'pass'
    };
  }

  return {
    status: 'fail',
    errors: errors
  };
};

exports.default = _default;